module.exports = __webpack_public_path__ + "img/financialperformance-436x218-susancosgrove.57d2bfde.jpg";